module.exports = __webpack_public_path__ + "assets/img/img63.62b506d5.png";